const KEY_ACC_MGT = "key-acc-mgt"
const SELECTED_YEAR_MONTH = "selectedYearMonth"
const SALES_DASH = "sales-dash"

export default {
    KEY_ACC_MGT,
    SELECTED_YEAR_MONTH,
    SALES_DASH
}